import { Component } from '@angular/core';
import { ManagedLinkKey, managedLinkInfo } from 'src/common/managedLinkKey';
import { ManagedLink } from 'src/common/managedLink';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/reducers';
import { Observable } from 'rxjs';
import { accesoBasesConocimientoCollapsed } from '../../home/store/acceso/acceso.selectors';
import { collapseAnimation } from '../access.animations';
import { BasesConocimientoToggleRequested } from '../../home/store/acceso/acceso.actions';

@Component({
	selector: 'bases-conocimiento',
	templateUrl: './bases-conocimiento.component.html',
	styleUrls: ['./bases-conocimiento.component.scss'],
	animations: [collapseAnimation]
})
export class BasesConocimientoComponent {

	isCollapsed$: Observable<boolean>;

	cardsConfig = [
		{ title: 'Up To Date', class: 'up-to-date-icon', key: ManagedLinkKey.UP_TO_DATE, isExternal: false },
		{ title: 'eDrugs - Vademecum', class: 'edrugs-vademecum-icon', key: ManagedLinkKey.EDRUGS, isExternal: false },
		{ title: 'Clinical Key', class: 'clinical-key-icon', key: ManagedLinkKey.CLINICAL_KEY, isExternal: false },
		{ title: 'Guías de prácticas clínicas', class: 'guias-de-practicas-clinicas-icon', key: ManagedLinkKey.GUIAS_PRACTICAS_CLINICAS, isExternal: false },
		{ title: 'Normas y procedimientos', class: 'normas-y-procedimientos-icon', key: ManagedLinkKey.NORMAS_PROCEDIMIENTOS, isExternal: false }
	];

	constructor( private legacyUrl: ManagedLink, private store: Store<AppState> ) {
		this.isCollapsed$ = this.store.select( accesoBasesConocimientoCollapsed );

		this.cardsConfig.forEach(function (config) {
			config.isExternal = managedLinkInfo[config.key].isExternal;
		});
	}

	toggleCollapse( event: Event ) {
		this.store.dispatch( new BasesConocimientoToggleRequested() );
		event.stopPropagation();
	}

}
